// frontend/src/_services/kitService.js
import api from '../../../api/axios';


// Al inicio del archivo
let encargadoNombre = null;

// 🟢 El hook llama a esto cada vez que alguien entra/sale
export const setEncargadoKits = (nombre) => {
  encargadoNombre = nombre;
};

const headersEncargado = () =>
  encargadoNombre ? { 'x-encargado-nombre': encargadoNombre } : {};

export const kitService = {
  /**
   * Obtener estado del sistema de kits
   */
  getEstado: async (slug) => {
    const response = await api.get(`/kit/competitors/${slug}/kits/estado`, {headers: headersEncargado()});
    return response.data;
  },

  /**
   * Activar sistema de kits (solo el primer admin)
   */
  activarSistema: async (slug, data) => {
    const response = await api.post(`/kit/competitors/${slug}/kits/activar`, data, {headers: headersEncargado()});
    return response.data;
  },

  /**
   * Registrar encargado (admin o editor)
   */
  registrarEncargado: async (slug, data) => {
    const response = await api.post(`/kit/competitors/${slug}/kits/encargado/registrar`, data, {headers: headersEncargado()});
    return response.data;
  },

  /**
   * Obtener encargados
   */
  getEncargados: async (slug) => {
    const response = await api.get(`/kit/competitors/${slug}/kits/encargados`, {headers: headersEncargado()});
    return response.data;
  },

  /**
   * Obtener rangos de dorsales
   */
  getRangos: async (slug) => {
    const response = await api.get(`/kit/competitors/${slug}/kits/rangos`, {headers: headersEncargado()});
    return response.data;
  },

  /**
   * Actualizar rangos de dorsales
   */
  actualizarRangos: async (slug, data) => {
    const response = await api.put(`/kit/competitors/${slug}/kits/rangos`, data, {headers: headersEncargado()});
    return response.data;
  },

  /**
   * Asignar dorsales automáticos
   */
  asignarDorsalesAutomaticos: async (slug) => {
    const response = await api.post(`/kit/competitors/${slug}/kits/asignar-dorsales`, {}, {headers: headersEncargado()});
    return response.data;
  },

  /**
   * Asignar dorsal manual
   */
  asignarDorsalManual: async (slug, id, data) => {
    const response = await api.put(`/kit/competitors/${slug}/kits/${id}/dorsal`, data, {headers: headersEncargado()});
    return response.data;
  },

  /**
   * Obtener lista de kits
   */
  getKits: async (slug, params = {}) => {
    const response = await api.get(`/kit/competitors/${slug}/kits`, { params, headers: headersEncargado() });
    return response.data;
  },

  /**
   * Obtener detalle de un kit
   */
  getKitDetalle: async (slug, id) => {
    const response = await api.get(`/kit/competitors/${slug}/kits/${id}`, {headers: headersEncargado()});
    return response.data;
  },

  /**
   * Entregar kit
   */
  entregarKit: async (slug, id, data) => {
    const response = await api.post(`/kit/competitors/${slug}/kits/${id}/entregar`, data, {headers: headersEncargado()});
    return response.data;
  },

  /**
   * Revertir entrega (solo admin)
   */
  revertirEntrega: async (slug, id, data) => {
    const response = await api.post(`/kit/competitors/${slug}/kits/${id}/revertir`, data, {headers: headersEncargado()});
    return response.data;
  },

  sincronizarCategorias: async (slug) => {
    const response = await api.post(`/kit/competitors/${slug}/kits/sincronizar-categorias`, {}, {headers: headersEncargado()});
    return response.data;
  },

  actualizarDatosCorredor: async (slug, id, datos) => {
    const response = await api.put(`/kit/competitors/${slug}/kits/${id}/datos`, { datos }, { headers: headersEncargado() });
    return response.data;
  },

  getColumnas: async (slug) => {
    const response = await api.get(`/kit/competitors/${slug}/kits/columnas`, { headers: headersEncargado() });
    return response.data;
  },
};